import { IBatchCheckResult } from "common/api/access.service";
import { IAccessData } from "common/records/Access";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { List, Map } from "immutable";

export const SET_ACCESS = "@access/SET_ACCESS";
export const RESET_ACCESS = "@access/RESET_ACCESS";
export const SET_ACCESS_ACL = "@access/SET_ACCESS_ACL";
export const RECEIVE_ACCESSES = "@access/RECEIVE_ACCESSES";
export const UPDATE_FORM_ACL = "@access/UPDATE_FORM_ACL";
export const UPDATE_FORM_RECORD = "@access/UPDATE_FORM_RECORD";
export const CLEAR_ACCESSES = "@access/CLEAR_ACCESSES";
export const RECEIVE_BATCH_CHECK = "@access/RECEIVE_BATCH_CHECK";

export const AccessActions = {
  setAccess: (id: number, access: IAccessData, overrideDirty = true) =>
    createAction(SET_ACCESS, { id, access, overrideDirty }),
  resetAccess: (id: number) => createAction(RESET_ACCESS, { id }),
  setAccessAcl: (id: number, acl: Map<string, List<string>>) => createAction(SET_ACCESS_ACL, { id, acl }),
  receiveAccesses: (accesses: IAccessData[], overrideDirty = true) =>
    createAction(RECEIVE_ACCESSES, { accesses, overrideDirty }),
  updateFormAcl: (id: number, resource: string, permission: string, value: boolean) =>
    createAction(UPDATE_FORM_ACL, { id, resource, permission, value }),
  updateFormRecord: (id: number, path: string, value: any) => createAction(UPDATE_FORM_RECORD, { id, path, value }),
  clearAccesses: () => createAction(CLEAR_ACCESSES),
  receiveBatchCheck: (orgId: number, results: IBatchCheckResult[]) =>
    createAction(RECEIVE_BATCH_CHECK, { orgId, results }),
};
export type AccessActions = ActionsUnion<typeof AccessActions>;
